import { SET_COMMENTS, SET_QUERIES, SET_FY_COUNT, SET_TOTAL_ENTITIES } from "../action/overview";

const initialState = {
    comments: [],
    totalMails: 0,
    queries: [],
    openCount: 0,
    fyCount: 0,
    totalEntities: 0
};

export default function overviewReducer(state = initialState, action) {
    switch (action.type) {
        case SET_COMMENTS:
            return {
                ...state,
                comments: action.payload.last5Comments,
                totalMails: action.payload.totalMails,
            };

        case SET_QUERIES:
            return {
                ...state,
                queries: action.payload.queries,
                openCount: action.payload.openCount,
            };

        case SET_FY_COUNT:
            return { ...state, fyCount: action.payload };
        case SET_TOTAL_ENTITIES:
            return { ...state, totalEntities: action.payload };

        default:
            return state;
    }
}